import React from 'react'
import PropTypes from 'prop-types'
import LayoutNoLogin from './NoLogin'
import styled from 'styled-components'

function LayoutMobile({ page, title, text, textStyles, noMenu, noLink, titleStyles }) {
  return (
    <LayoutNoLogin
      page={page}
      title={title}
      text={text}
      noMenu={noMenu}
      noLink={noLink}
      textStyles={textStyles}
      titleStyles={titleStyles}
    />
  )
}

LayoutMobile.propTypes = {
  page: PropTypes.node,
  title: PropTypes.string,
  text: PropTypes.string,
  noMenu: PropTypes.bool,
  noLink: PropTypes.bool,
  textStyles: PropTypes.instanceOf(styled.style),
}

export default LayoutMobile

/*
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Color, Border } from '../../../../const'
import { GlobalHeader } from '../../../shard'
import { useHistory } from 'react-router-dom'
import PageTitle from './PageTitle'
import BackArrow from './BackArrow'
import HamburgerMenu from './HamburgerMenu'
import { useAccountHook } from 'hooks'

function LayoutMobile({ page, title, noSeparator, noMenu, noBackArrow, noLink, isTop }) {
  const history = useHistory()

  const { user, execGetUser } = useAccountHook()
  useEffect(() => {
    if (isTop) {
      execGetUser()
    }
  }, [execGetUser, isTop])

  let separator = <Separator />

  if (noSeparator) {
    separator = ''
  }

  let hamburgerMenu = <HamburgerMenu history={history} />

  if (noMenu) {
    hamburgerMenu = ''
  }

  let backArrow = <BackArrow history={history} />

  if (noBackArrow) {
    backArrow = ''
  }

  return (
    <Wrapper>
      <BackLinkWrapper>{backArrow}</BackLinkWrapper>
      <GlobalHeaderWrapper>
        <GlobalHeader noLink={noLink} />
      </GlobalHeaderWrapper>
      <SideMenuWrapper>{hamburgerMenu}</SideMenuWrapper>
      <PageWrapper>
        <PageTitle isTop title={isTop ? `こんにちは${user?.lastname || ''} ${user?.firstname || ''}様` : title} />
        {separator}
        <PageArea>{page}</PageArea>
      </PageWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 23px 1fr 133px 1fr 22px 23px;
  grid-template-rows: 58px 1fr;
  width: 100%;
  height: 100vh;
`

const BackLinkWrapper = styled.div`
  grid-column: 2;
  grid-row: 1;
  padding-top: 17px;
`

const GlobalHeaderWrapper = styled.div`
  grid-column: 3;
  grid-row: 1;
  background: ${Color.BACKGROUND.BASE};
`

const SideMenuWrapper = styled.div`
  grid-column: 5;
  grid-row: 1;
`

const PageWrapper = styled.div`
  grid-column: 1 / 7;
  grid-row: 2;
  border-top: ${Border.BASE};
  display: flex;
  flex-direction: column;
`

const Separator = styled.div`
  flex: 0 0 10px;
  background-color: ${Color.LINE.PAGE_TITLE};
`

const PageArea = styled.div`
  flex: 1 1 0;
`

LayoutMobile.propTypes = {
  page: PropTypes.node,
  title: PropTypes.string,
  noSeparator: PropTypes.bool,
  noLink: PropTypes.bool,
  noBackArrow: PropTypes.bool,
  noMenu: PropTypes.bool,
}

export default LayoutMobile
*/
